var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#001E3C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.07 11.86a.47.47 0 0 1-.14-.35c0-.29.22-.5.5-.5h8.14c.28 0 .5.22.5.5a.5.5 0 0 1-.5.5H7.43a.5.5 0 0 1-.35-.14v-.01Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.14 15.93a.47.47 0 0 1-.14-.35l.01-8.14c0-.28.22-.5.5-.5s.5.22.5.5v8.14a.5.5 0 0 1-.5.5.5.5 0 0 1-.36-.14Z"
}))));
export { SvgAdd as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWNkMmMwYzZlYjliOTUxZDVkOTI2MWZlYjkwNTcwZmQuc3ZnIjs=";